import { useState, useEffect } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useUser } from "../context/UserContext"

import logo from "../images/logo_black.png"

const Login = () => {
  const [usuario, setUsuario] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  const navigate = useNavigate()
  const { setUser } = useUser()

  // PASO 4
  // Si ya hay token, no debería poder entrar al login
  useEffect(() => {
    const token = localStorage.getItem("token")

    if (token) {
      navigate("/")
    }
  }, [navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    try {

      
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cuit: usuario,   // 👈 único cambio
          password: password,
        }),
      })

      const data = await res.json()

      if (!res.ok) {
        throw new Error(data.message || "Error en login")
      }

      localStorage.setItem("token", data.token)
      localStorage.setItem("usuario", usuario)

      const meRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${data.token}` },
      })
      const userData = await meRes.json()
      setUser(userData)

      navigate("/")
    } catch (err) {
      console.error(err.message)
      setError("Usuario o contraseña incorrectos")
    }
  }

  return (
    <div className="login column">
      <div className="loginCard column">
        <div className="loginHeader column">
          <img className="loginLogo" src={logo} alt="Logo portalOS" />
          <div className="loginTitle">INGRESO</div>
        </div>

        <form onSubmit={handleSubmit} className="login-form column">
          <label htmlFor="login-cuit">Usuario</label>
          <input
            id="login-cuit"
            type="text"
            autoComplete="username"
            placeholder="Usuario"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
          />

          <label htmlFor="login-password">Contraseña</label>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="loginError" role="alert">{error}</div>

          <button type="submit">Iniciar sesión</button>
          <Link to="/cambiar-password" className="loginForgot">cambiar contraseña</Link>
        </form>
      </div>
    </div>
  )
}

export default Login